<template>
    <aside class="user-account__vip-bar">
        <h2 class="user-account__vip-bar-title">{{ trans('VIP client') }}</h2>
        <p class="user-account__vip-bar-discount">
            <span class="user-account__vip-bar-percent">-{{ percent }}%</span>
            <span class="user-account__vip-bar-discount-text">{{ trans('VIP discount forever') }}</span>
        </p>
        <p class="user-account__vip-bar-hint">{{ trans('VIP discount cart hint') }}</p>
        <p class="user-account__vip-bar-hint">{{ trans('VIP discount offline hint') }}</p>
    </aside>
</template>

<script>
export default {
    name: 'VipInfoBar',
    props: {
        discountPercent: {
            type: Number,
            default: 30,
        },
    },
    computed: {
        percent() {
            return Math.round(this.discountPercent)
        },
    },
}
</script>
